import { stringToArray } from '../utils/employer/stringArrayHandle.utils'

export function convertDataToDict(data) {
  const resultDict = {}

  function traverse(node, parentKey = '') {
    const currentKey = `${parentKey}${node.text}`
    resultDict[currentKey] = (node.child || [])
      .map((child) => child.Id)
      .join(',')
  }

  for (const item of data) {
    traverse(item)
  }

  return resultDict
}

export function replaceNumbersWithKeys(inputString = '', keyDictionary) {
  const numbersArray = inputString.split(',').map(Number)
  const resultKeys = []

  for (const key in keyDictionary) {
    const keyNumbers = keyDictionary[key].split(',').map(Number)
    const matchingNumbers = numbersArray.filter((num) =>
      keyNumbers.includes(num)
    )

    if (
      matchingNumbers.length >= 3 ||
      (key === 'Logistics and storage' && matchingNumbers.length > 1) ||
      (key === 'Other' && matchingNumbers.length === 1)
    ) {
      resultKeys.push(key)
      numbersArray.splice(
        0,
        numbersArray.length,
        ...numbersArray.filter((num) => !matchingNumbers.includes(num))
      )
    }
  }

  return resultKeys.length > 0
    ? resultKeys.join(',') +
        (numbersArray.length > 0 ? ', ' + numbersArray.join(',') : '')
    : inputString
}

export function isNumber(str) {
  return !isNaN(Number(str))
}

export function extractNumbers(inputString) {
  const elements = inputString.split(',').map((el) => el.trim())

  const numbersArray = elements
    .filter((el) => !isNaN(el))
    .map((el) => parseInt(el, 10))

  return numbersArray.join(',')
}
export function extractNonNumbers(inputString) {
  const elements = inputString.split(',').map((el) => el.trim())

  const nonNumbersArray = elements.filter((el) => isNaN(el))

  return nonNumbersArray.join(',')
}

export function replaceStringsWithNumbers(inputString, replacementDict) {
  for (const key in replacementDict) {
    const regex = new RegExp(`\\b${replacementDict[key]}\\b`, 'g')
    inputString = inputString.replace(regex, key)
  }
  return inputString
    .split(',')
    .filter((item) => !isNaN(item))
    .join(',')
}

// Render industry value
export const renderList = (array, translationKey, t) => {
  return array.map((el, index) => {
    const separator = index < array.length - 1 ? ', ' : ''
    return (
      <p key={index} style={{ margin: 0 }}>
        {t(`${translationKey}.${el}`) + separator}
        <br />
      </p>
    )
  })
}

export const industryRender = (
  industryType,
  areaOfWorkDict,
  t,
  translationKey_areaOfWork,
  translationKey_areaOfExpertiseList
) => {
  // If there is more than 3 options are choosen show the expertise name
  const industry = replaceNumbersWithKeys(industryType, areaOfWorkDict)

  const childValue = extractNumbers(industry) // area of work
  const parentValue = extractNonNumbers(industry) // area of expertise
  // Replace parent value with number for translation purpose
  const parentValue_num = replaceStringsWithNumbers(
    parentValue,
    areaOfExpertise
  )

  const childArray = stringToArray(childValue)
  const parentArray = stringToArray(parentValue_num)

  return (
    <>
      {renderList(childArray, translationKey_areaOfWork, t)}
      {renderList(parentArray, translationKey_areaOfExpertiseList, t)}
    </>
  )
}

export const areaOfExpertise = {
  1: 'Humanities',
  2: 'Development',
  3: 'Service',
  4: 'Industrial',
  5: 'Construction and maintenance',
  6: 'Marketing and sales',
  7: 'Finances and personnel',
  8: 'Health and wellbeing',
  9: 'Law and finance',
  10: 'Logistics and storage',
  11: 'Other'
}
